import React, {Component} from "react";
import {connect} from "react-redux";
import {Stack, Tooltip} from "@mui/material";
import {getPreviewUrl} from "../../../utils/utils";
import {mapSlideToProps} from "../../../redux_reducers/utils";
import {defaultPreview, Loader} from "utils/const";
import {getDicomThumbnails} from "../../../utils/api";


class Thumbnail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentRotation: 0,
            isThumbnailErrored: false,
            imageData: null,
            isFetchingThumbnail: true,
        }
    }

    componentDidMount() {
        this.getThumbnailUrl();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.loadingState.loading && !this.props.loadingState.loading) {
            this.getThumbnailUrl();
        }
    }

    getThumbnailUrl = () => {
        if(!this.props.loadingState.loading) {
            if (this.props.is_dicom) {
                getDicomThumbnails(this.props.slide.id, false)
                    .then(data => this.setState({imageData: data, isFetchingThumbnail: false}))
                    .catch(_ => this.setState({imageData: '', isFetchingThumbnail: false}))
            }else{
                let thumbnailUrl = getPreviewUrl(this.props.slide.preview_image.replace("stitched_small_viewer", "selection_marked"), this.props.slide)
                this.setState({
                    imageData: thumbnailUrl,
                    isFetchingThumbnail: false,
                })
            }
        }
    }

    rotate = () => {
        let rotation = this.state.currentRotation;
        rotation = (rotation + 180) % 360
        this.setState({
            currentRotation: rotation,
        })
        document.getElementById('thumbnail-img').style.transformOrigin = "50% 50%"
        document.getElementById('thumbnail-img').style.transform = `rotate(${rotation}deg)`
    }

    render() {
        return <Stack height={"100%"} width={"100%"} justifyContent={"center"} alignItems={"center"}>
            {(this.props.loadingState?.loading || this.state.isFetchingThumbnail) ? <Loader/> :
                <Tooltip title={this.state.isThumbnailErrored ? "" : "Click to Rotate 180"}>
                    <img id='thumbnail-img' alt={'thumbnail'}
                         src={this.props.is_dicom ? this.state.imageData : getPreviewUrl(this.props.slide.preview_image.replace("stitched_small_viewer", "selection_marked"), this.props.slide)}
                         style={{width: "100%", cursor: this.state.isThumbnailErrored ? 'auto' : 'pointer'}}
                         onClick={this.state.isThumbnailErrored ? null : this.rotate}
                         onError={({event, currentTarget}) => {
                             if (currentTarget) {
                                 this.setState({isThumbnailErrored: true})
                                 currentTarget.src = defaultPreview;
                             }
                             if (event?.currentTarget) event.currentTarget.onerror = null; // prevents looping
                         }}
                    />
                </Tooltip>}
        </Stack>
    }
}

export default connect(mapSlideToProps)(Thumbnail);
